import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import auth from './modules/auth'
Vue.use(Vuex)

const debug = process.env.VUE_APP_MODE !== 'production'

const store = new Vuex.Store({
  modules: {
    user: user,
    auth: auth
  },
  strict: debug
})

export default store
